import { getDirectionsApi } from './GoogleAPIFunctions';
import { getReturnDistanceToVienna, isWithinVienna } from './ViennaTariffRules';

export const GetDistance = (lat1, lon1, lat2, lon2) => {
    if ((lat1 === lat2) && (lon1 === lon2)) {
        return 0;
    }
    else {
        var radlat1 = Math. PI * lat1 / 180;
        var radlat2 = Math.PI * lat2 / 180;
        var theta = lon1 - lon2;
        var radtheta = Math.PI * theta / 180;
        var dist = Math. sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
        if (dist > 1) {
            dist = 1;
        }
        dist = Math. acos(dist);
        dist = dist * 180 / Math.PI;
        dist = dist * 60 * 1.1515;
        dist = dist * 1.609344;
        return dist;
    }
};

export const GetTripDistance = async (data, useGoogleAPI = true) => {
    if (data) {
        const arr = Object.keys(data)
            .filter(function (i) {
                return data[i].status == 'STARTED' || data[i].status == 'REACHED'
            })
            .map(i => {
                data[i].id = i
                return data[i]
            });
        let distance = 0;
        let coords = [];
        let returnDistance = 0;
        let timeInSeconds = 0;
        let routeData = null;
        
        try{
            if (arr. length == 0 || arr. length == 1) {
                distance = 0;
            } else if (arr.length >= 2) {
                coords = arr.map(point => ({
                    latitude: point.lat,
                    longitude: point.lng
                }));

                // Try to use Google Directions API for accurate route
                if (useGoogleAPI) {
                    try {
                        const startLoc = `${arr[0].lat},${arr[0].lng}`;
                        const destLoc = `${arr[arr.length - 1].lat},${arr[arr.length - 1].lng}`;
                        
                        // Build waypoints if more than 2 points
                        let waypoints = null;
                        if (arr. length > 2) {
                            waypoints = arr.slice(1, -1)
                                .map(p => `${p.lat},${p.lng}`)
                                .join('|');
                        }
                        
                        routeData = await getDirectionsApi(startLoc, destLoc, waypoints);
                        distance = routeData.distance_in_km;
                        timeInSeconds = parseFloat(routeData.time_in_secs);
                        
                    } catch (apiError) {
                        // Fall back to haversine
                        for (let i = 0; i < (arr.length - 1); i++) {
                            distance += GetDistance(arr[i].lat, arr[i].lng, arr[i + 1].lat, arr[i + 1].lng);
                        }
                    }
                } else {
                    // Use straight-line calculation
                    for (let i = 0; i < (arr.length - 1); i++) {
                        distance += GetDistance(arr[i].lat, arr[i].lng, arr[i + 1].lat, arr[i + 1].lng);
                    }
                }
                
                // Check if final destination is outside Vienna
                const finalDestLat = arr[arr.length - 1].lat;
                const finalDestLng = arr[arr.length - 1].lng;
                if (! isWithinVienna(finalDestLat, finalDestLng)) {
                    returnDistance = getReturnDistanceToVienna(finalDestLat, finalDestLng);
                }
            }
        }catch(error){
        }
        
        return {
            distance: distance,
            returnDistance: returnDistance,
            totalDistance: distance + returnDistance,
            timeInSeconds: timeInSeconds,
            coords: coords,
            outsideVienna: returnDistance > 0,
            routeData: routeData // Include full route data
        };
    }
    else {
        return {
            distance:  0,
            returnDistance:  0,
            totalDistance:  0,
            timeInSeconds: 0,
            coords:  [],
            outsideVienna:  false,
            routeData:  null
        };
    }
}